import { Badge, Button, Panel, StatCell } from '../../../components/ui';
import { formatCount, formatDateTime } from '../../../lib/format';
import type { EmailCampaignsData } from '../types';
import { EMAIL_PROVIDER_LABEL } from '../vocabulario';

/**
 * Barra de status do motor de e-mail.
 *
 * Decisoes nao obvias:
 *  1. O primeiro StatCell e o estado do provedor: enquanto Brevo x Resend
 *     nao for decidido, mostra "Provedor a definir" em aviso -- e nesse
 *     estado "agendados vencidos" e um numero que a pessoa precisa ver,
 *     porque nada vai sair sozinho.
 *  2. "Domínios autenticados" conta as empresas com SPF e DKIM ok: sem os
 *     dois, o e-mail cai em spam por mais que o texto seja bom.
 *  3. O teste de entrega abre o modal DETALHADO (por empresa, regra a
 *     regra), e nao um campo solto: testar so "chegou ou nao" esconde por
 *     que nao chegou.
 */
export function BarraStatusEmail({ data, onTesteDeEntrega }: { readonly data: EmailCampaignsData; readonly onTesteDeEntrega: () => void }): JSX.Element {
  const operacional = data.providerState === 'operacional';
  const autenticados = data.domains.filter((d) => d.spf === 'ok' && d.dkim === 'ok').length;
  const comFalha = data.domains.length - autenticados;

  return (
    <Panel className="flex flex-wrap items-center gap-x-2 px-5 py-2 md:divide-x md:divide-line">
      <StatCell
        label="Motor de e-mail"
        value={
          <Badge tone={operacional ? 'good' : 'warning'} dot>
            {EMAIL_PROVIDER_LABEL[data.providerState]}
          </Badge>
        }
        hint={operacional ? undefined : 'Brevo ou Resend: decisão pendente'}
      />
      <StatCell label="Último envio" value={data.lastSentAt === null ? '—' : formatDateTime(data.lastSentAt)} />
      <StatCell label="Agendados vencidos" value={formatCount(data.overdueScheduled)} tone={data.overdueScheduled > 0 ? 'critical' : 'neutral'} hint={data.overdueScheduled > 0 ? 'passaram da hora sem sair' : 'nenhum atrasado'} />
      <StatCell label="Enviando agora" value={formatCount(data.sendingNow)} tone={data.sendingNow > 0 ? 'info' : 'neutral'} />
      <StatCell
        label="Domínios autenticados"
        value={`${formatCount(autenticados)} de ${formatCount(data.domains.length)}`}
        tone={comFalha > 0 ? 'warning' : 'good'}
        hint={comFalha > 0 ? `${formatCount(comFalha)} sem SPF ou DKIM ok` : 'SPF e DKIM ok em todas'}
      />
      <div className="flex min-w-0 flex-1 items-center justify-end py-2 md:pl-4">
        <Button variant="secondary" size="sm" icon="escudo" onClick={onTesteDeEntrega}>
          Teste de entrega detalhado
        </Button>
      </div>
    </Panel>
  );
}
